import { AppValues, API, ApiSound } from "../Values";
import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Button, Dropdown } from "react-bootstrap";
import useSound from 'use-sound';
import { useAudio } from "../../AudioContext"; // استيراد الدالة من السياق

export default function LoginAdmin() {
  const { enableAudio } = useAudio();
  const params = useParams();
  //---------ShowModal----------------------------
  const [ShowModal, SetShowModal] = useState(false);
  const [ModalRegisterType, SetModalRegisterType] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);

  const handleCloseModalRegisterType = () => SetModalRegisterType(false);
  const handleShowModalRegisterType = () => SetModalRegisterType(true);
  const navigate = useNavigate();
  const [errors, Seterrors] = useState("");
  const [Info, SetInfo] = useState([]);
  const [inputs, setInputs] = useState({
    UserName: "",
    Password: "",
  });

  useEffect(() => {
    Login();
  }, []);
  const Login = async () => {
    try {
      if (params.typelogin != "app") {
        return false;
      }
      const post = {
        Action: "Login",
        username: params.username,
        password: params.password,
      };
      const response = await fetch(API.Login, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      if (data.msg == "success") {
        Cookies.set("LoginType", data.LoginType, { expires: 10 }); // Sets a cookie for 365 days
        Cookies.set("AccountNumber", data.AccountNumber, { expires: 10 }); // Sets a cookie for 365 days
        Cookies.set("userinfo", JSON.stringify(data.data), { expires: 10 }); // Sets a cookie for 365 days
        if (data.LoginType == "admin") {
          Cookies.set("admininfo", JSON.stringify(data.data), { expires: 10 }); // Sets a cookie for 365 days
        }
        return navigate("../admin");
      }
      if (data.errors != "") {
        Seterrors(data.errors);
        handleShowModal();
      }
      if (response.ok) {
      } else if (response.status === 400) {
        return alert("errorr 400");
      } else {
        return alert("can not save ");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="row bg-syan0 m-0" style={{ height: "100vh", backGround: "#0073B1" }}>
        <div className="col-12 p-4">
          <div
            dir="rtl"
            className="row pt-4 bg-white p-1 text-dark"
            style={{ maxWidth: "500px", margin: "auto", borderRadius: "30px" }}
          >
            <img
              style={{ width: "150px", margin: "auto" }}
              src="../../logo.png"
              alt=""
            />
            <h2 className="fw-bold my-2 mt-4 text-center"> مرحبا ! </h2>
            <h6 className="fw-bold my-2 text-center">تسجيل  دخول الادارة </h6>
          </div>
        </div>
      </div>
      <MSG />
    </>
  );
  function MSG() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 text-center">
                <h4 className="text-start p-0 m-0">خطا </h4>
                <hr />
                <h5
                  dir="ltr"
                  style={{ fontSize: "14px" }}
                  className=" text-center "
                >
                  {errors}
                </h5>
                <button
                  style={{ fontSize: "14px" }}
                  onClick={() => handleCloseModal()}
                  className="btn btn-danger w-50 m-3"
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }

}
